<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ recruitmentTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ recruitmentSubtitle1 | translate }}
            </p>
        </div>

        <form class="list" [formGroup]="formGroup">
            <textarea class="text-area" [disabled]="true"
                >{{ textrecruitment | translate }}
            </textarea>
            <div class="texto">
                <input type="checkbox" formControlName="recruit" id="recruit" class="box" (change)="onChangeRecuitment($event)" />
                <label class="text-paragraph-description" for="recruit">{{ checkrecruitment | translate }}</label>
            </div>
            <div class="text-info">
                <span class="text-description">{{ inforecruitment | translate }}</span>
            </div>
        </form>
        <!-- 
        
        <form class="form" [formGroup]="formGroup">

        </form>
 -->
        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>

<!-- 

<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="headlines">
        <span *ngIf="!isPortraitDevice" class="text-headline-title">
            {{ recruitmentTitle | translate }}
        </span>
        <span class="text-paragraph">
            {{ recruitmentSubtitle1 | translate }}
        </span>
    </div>

    <form class="list" [formGroup]="formGroup">
        <textarea class="text-area" [disabled]="true"
            >{{ textrecruitment | translate }}
        </textarea>
        <div class="texto">
            <input type="checkbox" formControlName="recruit" id="recruit" class="box" (change)="onChangeRecuitment($event)" />
            <label class="text-paragraph-description" for="recruit">{{ checkrecruitment | translate }}</label>
        </div>
        <div class="text-info">
            <span class="text-description">{{ inforecruitment | translate }}</span>
        </div>
    </form>

    <div class="actions">
        <button
            *ngIf="!isPortraitDevice"
            pripple=""
            class="button-secondary button-next"
            type="button"
            [disabled]="backButtonDisabled"
            (click)="onClicButtonBack()"
        >
            <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
            <span class="p-button-label-right">{{ backButton | translate }}</span>
        </button>

        <button
            pripple=""
            class="button-primary button-next"
            type="button"
            [disabled]="continueButtonDisabled"
            (click)="onClicButtonContinue()"
            [ngClass]="{ 'is-portrait': isPortraitDevice }"
        >
            <span class="p-button-label-left">{{ continueButton | translate }}</span>
            <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
        </button>
    </div>
</div>
 -->
